import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'

/**
 * Whether the Drafts destination is available to the current user.
 */
export function isDraftsDestinationEnabled(): boolean {
  return kGetFeatureFlagStatus(kFeatureFlags.DRAFTS_DESTINATION)
}
